import { Container, Grid, IconButton, useTheme } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { GetTransfer, GetTransferAmountMax } from "store/api/transfer";
import { useEffect, useMemo, useState } from "react";

import CoinDrawerSelect from "components/CoinDrawerSelect";
import FullWidthModal from "components/FullWidthModal";
import TransferAmount from "./Components/TransferAmount";
import TransferSide from "./Components/TransferSide";
import TransferSubmit from "./Components/TransferSubmit";
import http from "config/http";
import { repeat } from "utils/helpers/interval";
import useNotify from "hooks/useNotify";
import { Link, useSearchParams } from "react-router-dom";
import { History } from "assets/Icon";
import { TRANSFER_SIDES } from "./contstants";
import { ROUTE_PATHS } from "routes/paths";

let getBorrowAmountMaxInterval;

function Transfer({ open, onClose }) {
  const notify = useNotify();
  const theme = useTheme();

  const [searchParams, setSearchParams] = useSearchParams();
  const coinId = +searchParams.get("transfer") || 1;
  const walletTypeId = +searchParams.get("transferWalletTypeId") || 2;
  const sideId = +searchParams.get("transferSideId") || 1;

  const [transferInitial, setTransferInitial] = useState();
  const [transferAmountMax, setTransferAmountMax] = useState();

  const methods = useForm({
    defaultValues: { coinId, sideId, walletTypeId, amount: "" },
  });

  const { reset } = methods;

  const getTransfer = async () => {
    try {
      const { data } = await http.get(
        GetTransfer({
          coinId,
          walletTypeId,
          sideId,
        })
      );

      setTransferInitial(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message);
    }
  };

  const getTransferAmountMax = async () => {
    try {
      const { data } = await http.get(
        GetTransferAmountMax({
          coinId,
          walletTypeId,
          sideId,
        })
      );

      setTransferAmountMax(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message);
    }
  };

  const handleChangeCoin = (data) => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, transfer: data?.id });
  };

  const selectedCoin = useMemo(
    () => transferInitial?.lisCoin?.find((coin) => coin?.id === coinId),
    [coinId, transferInitial?.lisCoin]
  );

  useEffect(() => {
    getTransfer();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (transferInitial?.validSeconds && coinId) {
      getTransferAmountMax();

      clearInterval(getBorrowAmountMaxInterval);

      getBorrowAmountMaxInterval = repeat({
        action: () => getTransferAmountMax(),
        time: transferInitial?.validSeconds * 1000,
      });
    }

    return () => {
      clearInterval(getBorrowAmountMaxInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinId, transferInitial, sideId, reset]);

  useEffect(() => {
    reset((formValues) => ({
      ...formValues,
      amount: "",
      sideId,
      walletTypeId,
      coinId,
    }));
  }, [sideId, coinId, walletTypeId, reset]);

  return (
    <FullWidthModal
      title="Transfer"
      open={open}
      onClose={onClose}
      extraActions={() => (
        <>
          {sideId !== TRANSFER_SIDES.MARGIN_TO_SPOT &&
            <IconButton
              aria-label="history"
              size="small"
              component={Link}
              to={ROUTE_PATHS.history.transfer}
              sx={{ ml: 1 }}
            >
              <History color={theme.palette.secondary.main} />
            </IconButton>
          }
        </>
      )}
    >
      <FormProvider {...methods}>
        <form>
          <Container>
            <Grid container spacing={2}>
              <TransferSide transferInitial={transferInitial} />

              <Grid item xs={12}>
                <CoinDrawerSelect
                  coinList={transferInitial}
                  selectedCoin={selectedCoin}
                  onCoinClick={handleChangeCoin}
                />
              </Grid>

              <TransferAmount
                transferAmountMax={transferAmountMax}
                selectedCoin={selectedCoin}
              />

              <TransferSubmit onClose={onClose} />
            </Grid>
          </Container>
        </form>
      </FormProvider>
    </FullWidthModal >
  );
}

export default Transfer;
